import { AuthLayout } from '@felix/ui';
import { IconCloudLock, IconFileCertificate, IconShip } from '@tabler/icons-react';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { LanguageSwitch } from './LanguageSwitch.js';

/** Giriş ekranlarının ortak çerçevesi: marka paneli, dil seçimi, form kartı. */
export function AuthScreen({ children, footnote }: { children: ReactNode; footnote?: ReactNode }) {
  const { t } = useTranslation();
  return (
    <AuthLayout
      headline={t('brand.headline')}
      subline={t('brand.subline')}
      features={[
        {
          icon: <IconShip size={20} />,
          title: t('brand.features.offline.title'),
          description: t('brand.features.offline.text'),
        },
        {
          icon: <IconFileCertificate size={20} />,
          title: t('brand.features.audit.title'),
          description: t('brand.features.audit.text'),
        },
        {
          icon: <IconCloudLock size={20} />,
          title: t('brand.features.sync.title'),
          description: t('brand.features.sync.text'),
        },
      ]}
      footnote={t('brand.footnote', { year: new Date().getFullYear(), version: __APP_VERSION__ })}
      toolbar={<LanguageSwitch />}
      formFootnote={footnote}
    >
      {children}
    </AuthLayout>
  );
}
